import React, { useState } from "react";
import SaveButton from "@/ui-controls/SaveButton";
import CancelButton from "@/ui-controls/CancelButton";
import TextInput from "@/ui-controls/TextInput";
import { Grid } from "fluentui-react-grid";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Application, updateApplication } from "@/api/applications";

interface Props {
  application: Application;
  onSave?: (app: Application) => any;
  onClose?: () => any;
}

const UpdateApplicationForm = (props: Props) => {
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const saveApplication = (application: Application) => {
    setIsSaving(true);

    let updatedApp = {
      ...props.application,
      Name: application.Name,
      Description: application.Description,
      ClientId: application.ClientId,
    };

    updateApplication(props.application.Id, updatedApp)
      .then(
        (result) => {
          if (props.onSave) props.onSave(updatedApp);
        },
        (error) => {
          // Error handling would go here in real app
        }
      )
      .finally(() => {
        setIsSaving(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      name: props.application.Name,
      description: props.application.Description,
      clientId: props.application.ClientId,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required").max(250),
      clientId: Yup.string().required("Client Id is required").max(250),
      description: Yup.string().required("Description is required").max(250),
    }),
    onSubmit: (values) => {
      const app = {
        Name: values.name,
        Description: values.description,
        ClientId: values.clientId,
        IsActive: true,
      } as Application;
      saveApplication(app);
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid dir="ltr">
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Name"
                baseTypeProps={{
                  disabled: isSaving,
                  ...formik.getFieldProps("name"),
                }}
                hasError={formik.errors.name && formik.touched.name}
                errorMessage={formik.errors.name}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Description"
                baseTypeProps={{
                  disabled: isSaving,
                  ...formik.getFieldProps("description"),
                }}
                hasError={
                  formik.errors.description && formik.touched.description
                }
                errorMessage={formik.errors.description}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col sizeSm={12}>
              <TextInput
                label="Client ID"
                baseTypeProps={{
                  disabled: isSaving,
                  ...formik.getFieldProps("clientId"),
                }}
                hasError={formik.errors.clientId && formik.touched.clientId}
                errorMessage={formik.errors.clientId}
              />
            </Grid.Col>
          </Grid.Row>
          <Grid.Row className="panel-buttons">
            <Grid.Col>
              <SaveButton
                text="Save"
                baseTypeProps={{ type: "submit", disabled: isSaving }}
              />
            </Grid.Col>
            <Grid.Col>
              <CancelButton
                text="Cancel"
                onClick={onCancelForm}
                baseTypeProps={{ disabled: isSaving }}
              />
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </form>
    </>
  );
};

export default UpdateApplicationForm;
